<!-- Agent review carousel mounted by src/vue/pages/reviews.js on agent detail pages. -->
<template>
	<carousel
		style="padding-top: 0px; margin-bottom: 0px; width: 100%;"
		:per-page="1"
		:pagination-enabled="false"
		:navigation-enabled="true"
		:adjustable-height="true"
		navigation-next-label=""
		navigation-prev-label=""
	>
		<slide v-for="(review, index) in reviews" :key="index">
			<div class="px-70 mx-70">
				<p class="text-gray600 italic mb-30" v-for="(reviewParagraph, index) in review.review" :key="index" v-html="reviewParagraph" />
				<div class="font-secondary text-gray700 text-xs font-bold uppercase tracking-loose" v-html="review.reviewer"></div>
			</div>
		</slide>
	</carousel>
</template>

<script>
	import Carousel from '../general/carousel.vue';
	import Slide from '../general/carousel-slide.vue';

	export default {
		emits: [],
		data() {
			return {
				reviews: window.reviews || []
			}
		},
		components: {
		    Carousel,
		    Slide
		}
	}
</script>

<style>
	.VueCarousel-navigation-button {
		background: #F4F2F2 !important;
		padding: 18px 29px !important;
		color: #4C5E67 !important;

		img { display: none; }
	}
</style>
